export default __webpack_public_path__ + "static/media/x_wdt_c_3.1d5088e9.mp3";